import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "./components/Header/header";
import Container from "./components/Container/container";
import About from "./components/About/about";
import Footer from "./components/Footer/footer";
import Registration from "./components/Registration/registration";
import Login from "./components/Login/login";
import Service from "./components/Services/service";
import Aboutus from "./components/About-Us/aboutus";
import Case from "./components/Cases/case";
import Nfc from "./components/Nfc/nfc";
import Admin from "./components/Admin/admin";
import Contact from "./components/Contact-Us/contact";
import Lawyers from "./components/Admin/lawyers";
import Customer from "./components/Admin/customer";
import LawyerRequest from "./components/Admin/lawyerrequests";
import Lawyerpanel from "./components/Lawyer-Panel/lawyerpanel";
import Customerpanel from "./components/Customer-Panel/customerpanel";
function App(Props) {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Header></Header>
                <Container></Container>
                <About></About>
                {/* <Nfc></Nfc> */}
                <Contact></Contact>
                <Footer></Footer>
              </>
            }
          ></Route>
          <Route
            path="/registration"
            element={
              <>
                <Header></Header>
                <Registration></Registration>
                <Contact></Contact>
                {/* <Nfc></Nfc> */}
                <Footer></Footer>
              </>
            }
          ></Route>
          <Route
            path="/login"
            element={
              <>
                <Header></Header>
                <Login ></Login>
                <Contact></Contact>
                {/* <Nfc></Nfc> */}
                <Footer></Footer>
              </>
            }
          ></Route>
          <Route
            path="/services"
            element={
              <>
                <Header></Header>
                <Service></Service>
                <Contact></Contact>
                {/* <Nfc></Nfc> */}
                <Footer></Footer>
              </>
            }
          ></Route>
          <Route
            path="/aboutus"
            element={
              <>
                <Header></Header>
                <Aboutus></Aboutus>
                <Contact></Contact>
                {/* <Nfc></Nfc> */}
                <Footer></Footer>
              </>
            }
          ></Route>
          <Route
            path="/cases"
            element={
              <>
                <Header></Header>
                <Case></Case>
                <Contact></Contact>
                {/* <Nfc></Nfc> */}
                <Footer></Footer>
              </>
            }
          ></Route>
          <Route
            path="/admin"
            element={
              <>
                <Header></Header>
                <Admin></Admin>
              </>
            }
          >
            {/* <Route
              path="/admin/allusers"
              element={
                <>
                  <Allusers></Allusers>
                </>
              }
            ></Route> */}
            <Route
              path="/admin/lawyers"
              element={
                <>
                  <Lawyers></Lawyers>
                </>
              }
            ></Route>


<Route
              path="/admin/lawyerRequest"
              element={
                <>
                  <LawyerRequest></LawyerRequest>
                </>
              }
            ></Route>


            <Route
              path="/admin/customer"
              element={
                <>
                  <Customer></Customer>
                </>
              }
            ></Route>
          </Route>
          {/* lawyer */}
          <Route
            path="/lawyers"
            element={
              <>
                <Header></Header>
                <Lawyerpanel></Lawyerpanel>
              </>
            }
          >
            <Route
              path="/lawyers/customer"
              element={
                <>
                  <Customer></Customer>
                </>
              }
            ></Route>
          </Route>
          {/* client */}
          <Route
            path="/customer"
            element={
              <>
                <Header></Header>
                <Customerpanel></Customerpanel>
              </>
            }
          >
            <Route
              path="/customer/lawyers"
              element={
                <>
                  <Lawyers></Lawyers>
                </>
              }
            ></Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
